export default function dataURItoBlob(dataURI) {
  let mimeTypeResults = dataURI.match(/^data:(image\/.+?);base64/);
  let mimeType;
  if (!mimeTypeResults) {
    throw new Error('Cannot process non image file.');
  } else {
    mimeType = mimeTypeResults[1];
  }
  // convert base64 to raw binary data held in a string
  let byteString = atob(dataURI.split(',')[1]);
  // write the bytes of the string to an ArrayBuffer
  let ab = new ArrayBuffer(byteString.length);
  let ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  // write the ArrayBuffer to a blob
  let bb = new Blob([ab], {
    type: mimeType
  });
  return bb;
}